<div>
    <div *ngIf="context.hasText('step-finalisation-description')" class="with-icon mat-caption">
        <mat-icon matPrefix>info</mat-icon><span class="ml" [innerHtml]="context.getText('step-finalisation-description')"></span>
    </div>
    
    <div fxLayout="row" fxLayoutAlign="space-around" fxLayoutGap="10px" fxLayout.lt-sm="column">
        <mat-checkbox fxFlex="100%" fxFlex.sm="100%" fxLayoutAlign="start center" name="consentement" [(ngModel)]="demande.consentement"><span style="font-style: italic" class="wrap">{{ context.getText('step-finalisation-placeholder-consentement', 'En soumettant ce formulaire, j\'accepte que les informations saisies soient exploitées dans le cadre de la demande d\'inscription et de la relation (commerciale) qui peut en découler') }}</span>
            <mat-icon *ngIf="context.hasText('step-finalisation-tooltip-consentement')" matSuffix [matTooltip]="context.getText('step-finalisation-tooltip-consentement')">help</mat-icon>
        </mat-checkbox>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-around" fxLayoutGap="10px" fxLayout.lt-sm="column">
        <button *ngIf="!context.sending" mat-raised-button type="button" [disabled]="!demande.consentement || !hasSelectedTarget() || !isHorairesValid() || !form" (click)="finish()" color="primary">{{ context.getText('step-finalisation-placeholder-submit', 'Envoyer ma demande') }}</button>
        <mat-spinner *ngIf="context.sending"></mat-spinner>
    </div>
</div>

            